import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { ReactComponent as ArrowdownSVG } from 'assets/icons/arrow-down.svg';
import { HintField } from 'components';
import React, { useEffect, useRef, useState } from 'react';
const LedgersMenu = ({ ledgers, formik, ledgerFieldValue, loading, index, hasError }) => {
  const [openLedgersMenu, setOpenLedgersMenu] = useState(false);
  const [showSubMenuId, setShowSubMenuId] = useState(null);
  const [activeLedger, setActiveLedger] = useState(null);
  const openLedgerMenuHandler = () => {
    setOpenLedgersMenu(!openLedgersMenu);
  };
  const subMenuOnMouseEnterHandler = (ledger) => {
    setShowSubMenuId(ledger?._id);
    setActiveLedger(ledger);
  };
  const subMenuOnMouseLeaveHandler = () => {
    setShowSubMenuId(null);
    setActiveLedger(null);
  };
  const menuRef = useRef();
  useEffect(() => {
    let handler = (event) => {
      if (!menuRef.current?.contains(event.target)) {
        setOpenLedgersMenu(false);
      }
    };
    document.addEventListener('mousedown', handler);
    return () => {
      document.removeEventListener('mousedown', handler);
    };
  });
  return (
    <div className="class_LedgersMenu">
      <button
        className={`class_LedgersMenu_btn${hasError ? ' is-invalid' : ''}`}
        onClick={openLedgerMenuHandler}
        ref={menuRef}
      >
        <div className="ledger_value">
          {formik?.values?.prices?.[index]?.ledger?.name}{' '}
          <span>{formik?.values?.prices?.[index]?.subLedger?.name}</span>
        </div>
        {!formik?.values?.prices?.[index]?.ledger?.name &&
          !formik?.values?.prices?.[index]?.subLedger?.name && (
            <span className="w-100 text-left">Ledger Name</span>
          )}
        <ul className="ledgers_ul">
          {openLedgersMenu &&
            ledgers?.map((ledger) => {
              if (!ledger?.sub_ledgers?.length)
                return (
                  <li
                    className="ledgers_li"
                    key={ledger?._id}
                    onClick={() => {
                      formik.setFieldValue(`prices[${index}].ledger`, {
                        id: ledger?._id,
                        name: ledger?.ledger_name,
                      });
                      formik.setFieldValue(`prices[${index}].subLedger`, undefined);
                      formik.setFieldValue(`prices[${index}].required_notes`, ledger?.notes);
                    }}
                    onMouseEnter={subMenuOnMouseLeaveHandler}
                  >
                    {ledger?.ledger_name}
                  </li>
                );
              return (
                <li
                  className="ledgers_li_with_subLed"
                  key={ledger?._id}
                  onMouseEnter={() => subMenuOnMouseEnterHandler(ledger)}
                // onMouseLeave={subMenuOnMouseLeaveHandler}
                // onClick={() => {
                //   formik.setFieldValue('ledger', {
                //     ledger_name: ledger?.ledger_name,
                //     ledger_id: ledger?._id,
                //   });
                // }}
                >
                  <div
                    onClick={() => {
                      formik.setFieldValue(`prices[${index}].ledger`, {
                        id: ledger?._id,
                        name: ledger?.ledger_name,
                      });
                      formik.setFieldValue(`prices[${index}].subLedger`, undefined);
                      formik.setFieldValue(`prices[${index}].required_notes`, ledger?.notes);
                      subMenuOnMouseLeaveHandler();
                    }}
                    className="w-100 text-left h-100"
                  >
                    {ledger?.ledger_name}
                  </div>
                  <KeyboardArrowRightIcon />
                </li>
              );
            })}
        </ul>
        {showSubMenuId === activeLedger?._id && (
          <ul className="sub_ledgers_ul"
            onMouseLeave={subMenuOnMouseLeaveHandler}
          >
            {activeLedger?.sub_ledgers?.map((subLedger) => {
              return (
                <li
                  className="sub_ledgers_li"
                  key={subLedger?._id}
                  onClick={() => {
                    formik.setFieldValue(`prices[${index}].ledger`, {
                      id: activeLedger?._id,
                      name: activeLedger?.ledger_name,
                    });
                    formik.setFieldValue(`prices[${index}].subLedger`, {
                      id: subLedger?._id,
                      name: subLedger?.sub_ledger_name,
                    });
                    subMenuOnMouseLeaveHandler();
                  }}
                >
                  {subLedger?.sub_ledger_name}
                </li>
              );
            })}
          </ul>
        )}
        {loading ? (
          <span className="mr-3 spinner spinner-gray"></span>
        ) : openLedgersMenu ? (
          <KeyboardArrowUpIcon />
        ) : (
          <KeyboardArrowDownIcon />
        )}
      </button>
      {hasError && <HintField error="Required" />}
    </div>
  );
};

export default LedgersMenu;
